import { useDataSubmit, useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  let tasks = useDataValue({
    context: 'selected',
    path: 'filtered_tasks',
    viewPath: props.viewPath,
  })

  let task_ids = useDataValue({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_bulk_tasks_stage',
      task_and_stage_ids: tasks
        .filter(task => task_ids.includes(task.id))
        .map(task => ({
          id: task.id,
          stage_id: task.board.stages.find(stage => stage.done).id,
        })),
    })

    change([])
  }
}
